module.exports = __webpack_public_path__ + "static/media/Header_kidsMobile.a270dd00.jpg";